import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'vi-info-panel',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: 'info-panel.component.html',
  styleUrls: ['info-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViInfoPanelComponent {
  @Input() imageSrc: string;
}
